var exports = {
  "HU": "BorderlessTextInput__gAKs7C",
  "Lk": "textAlignRight__-24Z78",
  "EY": "Text__x6rtDk",
  "Ku": "baseCell__UQaZEO",
};

module.exports = exports;
